import { createSearchParams, useNavigate } from "react-router-dom";

// Constants
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";

// Icons
import Rows from "assets/icons/glory/sort-provider.svg?react";

import "./styles.sass";

const GameSortButton = () => {
  const navigate = useNavigate();

  const handleSortClick = () => {
    navigate({
      search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.sortProvider })}`,
    });
  };

  return (
    <div className="GameSortButton" onClick={handleSortClick}>
      <Rows />
    </div>
  );
};

export default GameSortButton;
